import * as searchJobsHorizonRouteExports from '#/modules/search/jobs/page/SearchJobs.horizon-route';
import { searchJobsRoutePaths } from '#/modules/search/jobs/routing/searchJobs.route-paths';
import { horizonRouteToObject } from '#/routing/utils/horizonRouteToObject';

export const searchJobsRouteObjects = searchJobsRoutePaths.map((path) => ({
  path,
  ...horizonRouteToObject(searchJobsHorizonRouteExports),
}));
